/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CurrencyExchangeConfigurationListRequest {
    getFixupPrototypeFunction() { return CurrencyExchangeConfigurationListRequest.fixupPrototype; }

    static newInstance(model: Partial<CurrencyExchangeConfigurationListRequest>): CurrencyExchangeConfigurationListRequest {
        let obj = Object.assign(new CurrencyExchangeConfigurationListRequest(), model);
        CurrencyExchangeConfigurationListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CurrencyExchangeConfigurationListRequest>): CurrencyExchangeConfigurationListRequest {
        if (!model) return null;
        return CurrencyExchangeConfigurationListRequest.newInstance(<CurrencyExchangeConfigurationListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CurrencyExchangeConfigurationListRequest) {
        if (!obj) return;

        models.CurrencyExchangeConfigurationListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CurrencyExchangeConfigurationListRequest): boolean {
        Object.setPrototypeOf(obj, CurrencyExchangeConfigurationListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.CurrencyExchangeConfigurationFilter.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.CurrencyExchangeConfigurationListSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.CurrencyExchangeConfigurationListSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.CurrencyExchangeConfigurationFilter;

}
